import { ResponsiveStyleValue } from '@mui/system';
import useBreakpoints from '../../../helpers/useBreakpoints';

export interface IUseLoginFlowButtons {
  buttonsDirection: ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'>;
  buttonsSpacing: number;
}

export function useLoginFlowButtons(): IUseLoginFlowButtons {
  const { downSm } = useBreakpoints();

  const buttonsDirection = (downSm ? 'column' : 'row') as ResponsiveStyleValue<
    'row' | 'row-reverse' | 'column' | 'column-reverse'
  >;
  const buttonsSpacing = downSm ? 2 : 1;

  return {
    buttonsDirection,
    buttonsSpacing,
  };
}
